import React from 'react';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import NavBar from './components/NavBar/NavBar';
import Home from './components/Home/Home';
import ProjectsProfile from './components/ProjectsProfile/ProjectsProfile';
import Api from './components/Api/Api';
import Projects from './components/Projects/Projects';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Skills from './components/Skills/Skills';
import Tools from './components/Tools/Tools';
import Blogs from './components/Blogs/Blogs';
import HomeDetails from './components/HomeDetails/HomeDetails';
function App() {
  return (
    <div style={{backgroundColor:"#000"}} className="App">
    <Router>
    <NavBar/>
    <Switch>
    <Route exact path="/">
    <Home/>
    </Route>
    <Route exact path="/home">
    <HomeDetails/>
    </Route>
    <Route exact path="/working">
    <Api/>
    </Route>
    <Route exact path="/Projects">
    <Projects/>
    </Route>

    <Route exact path="/About">
      <About/>
    </Route>
    <Route exact path="/Contact">
      <Contact/>
    </Route>
    <Route exact path="/Skills">
      <Skills/>
    </Route>
    <Route exact path="/blogs">
      <Blogs/>
    </Route>
    <Route exact path="/Tools">
      <Tools/>
    </Route>
    
    </Switch>
    </Router>
    <h6 className="text-center">Made With 💚 Rian Islam</h6>
    </div>
  );
}

export default App;
